import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import TextDropdown from 'src/components/TextDropdown/TextDropdown'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface DepartmentsFilterProps {
  departmentsSet: Set<string>
  handleDepartmentsSelection: (departmentId: string) => Set<string>
  setDepartmentsSet: (departments: Set<string>) => void
  departmentsOptions: Array<{
    value: string
    details: {
      text: string
    }
  }>
  defaultFilters: {
    departments?: Set<string>
  }
}

const DepartmentsFilter: React.FC<DepartmentsFilterProps> = ({
  departmentsSet,
  handleDepartmentsSelection,
  setDepartmentsSet,
  departmentsOptions,
  defaultFilters,
}) => {
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <>
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Team'} />
      </div>
      <TextDropdown
        id={'departmentDropdown'}
        css={css`
          margin-top: 8px;
        `}
        placeholder={translateSingleString(locale, 'All teams')}
        chooseOption={(val: string): void => {
          handleDepartmentsSelection(val)
        }}
        isMulti={true}
        selectedValues={departmentsSet}
        optionGroups={[
          {
            options: departmentsOptions,
          },
        ]}
        onResetClick={(): void => {
          setDepartmentsSet(defaultFilters.departments || new Set<string>())
        }}
      />
    </>
  )
}

export default DepartmentsFilter
